module.exports = __webpack_public_path__ + "img/frwardarw.cc2eeefb.svg";